import React from "react";

const ResMedLogo = ({
  name = "resmedlogo",
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  height = "100%",
  viewBox = "0 0 59 44"
}) => (
  <svg
    style={style}
    width={width}
    height={height}
    className={className}
    viewBox="0 0 59 44"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Logo/white</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Step-1" transform="translate(-27.000000, -775.000000)">
        <g
          id="Logo/white"
          transform="translate(27.000000, 775.000000)"
          fill="#FFFFFF"
        >
          <g id="white_Logo">
            <g id="Oval-Shapes" fillRule="nonzero">
              <ellipse
                id="Oval"
                transform="translate(56.874280, 17.477369) rotate(-2.739664) translate(-56.874280, -17.477369) "
                cx="56.8742805"
                cy="17.4773687"
                rx="1.94563201"
                ry="1.94883628"
              ></ellipse>
              <path
                d="M55.4795041,20.9522645 C55.4331818,19.9839956 54.6140083,19.2357877 53.6485537,19.2846902 C52.6830992,19.3311475 51.9370661,20.1527091 51.9833884,21.120978 C52.0297107,22.089247 52.8488843,22.8350097 53.8143388,22.7909975 C54.7797934,22.742095 55.5258264,21.9205335 55.4795041,20.9522645 Z"
                id="Shape"
              ></path>
              <path
                d="M51.8102893,23.5807724 C51.768843,22.7103084 51.032562,22.0378994 50.1621901,22.0794665 C49.2942562,22.1210336 48.6238017,22.8619061 48.6652479,23.7323701 C48.7066942,24.6028341 49.4454132,25.2752431 50.3133471,25.233676 C51.181281,25.1921089 51.8517355,24.4536816 51.8102893,23.5807724 Z"
                id="Shape"
              ></path>
              <ellipse
                id="Oval"
                transform="translate(46.502733, 25.141718) rotate(-2.722496) translate(-46.502733, -25.141718) "
                cx="46.5027326"
                cy="25.1417179"
                rx="1.41653629"
                ry="1.42064966"
              ></ellipse>
              <path
                d="M44.0622727,25.3265907 C44.0281405,24.61995 43.4308264,24.0746874 42.7262397,24.1089191 C42.0216529,24.1431509 41.4779752,24.7422062 41.5121074,25.4464018 C41.5462397,26.1505974 42.1435537,26.6983051 42.8481405,26.6640734 C43.5527273,26.6298416 44.0939669,26.0307863 44.0622727,25.3265907 Z"
                id="Shape"
              ></path>
              <path
                d="M40.6368595,24.3069742 C40.6076033,23.671242 40.0688017,23.1822173 39.4349174,23.2115588 C38.8010331,23.2433454 38.3109917,23.7812726 38.342686,24.4170047 C38.3719421,25.0527369 38.9107438,25.5442067 39.5446281,25.5148652 C40.1785124,25.4806335 40.6661157,24.9402612 40.6368595,24.3069742 Z"
                id="Shape"
              ></path>
              <ellipse
                id="Oval"
                transform="translate(36.841913, 22.538310) rotate(-2.733941) translate(-36.841913, -22.538310) "
                cx="36.8419132"
                cy="22.5383101"
                rx="1.03376443"
                ry="1.0367662"
              ></ellipse>
              <path
                d="M35.7096281,20.3018616 C35.6852479,19.7883857 35.248843,19.3898305 34.7344215,19.4142817 C34.222438,19.438733 33.8250413,19.8764101 33.8518595,20.3898861 C33.8762397,20.9058072 34.3102066,21.3019172 34.8246281,21.277466 C35.3366116,21.2530147 35.7340083,20.8153376 35.7096281,20.3018616 Z"
                id="Shape"
              ></path>
              <path
                d="M33.9981405,18.0010003 C33.9761983,17.5388719 33.5836777,17.1818839 33.1228926,17.20389 C32.6621074,17.2258961 32.303719,17.619561 32.3256612,18.0816894 C32.3476033,18.5438177 32.740124,18.9032509 33.2009091,18.8812448 C33.6641322,18.8592387 34.0200826,18.4655738 33.9981405,18.0010003 Z"
                id="Shape"
              ></path>
              <path
                d="M32.6499174,15.6952487 C32.6304132,15.2771325 32.2769008,14.9568213 31.862438,14.9763823 C31.4455372,14.9959433 31.126157,15.3504862 31.1456612,15.7661573 C31.1676033,16.1842734 31.5186777,16.5045846 31.9355785,16.4850236 C32.3500413,16.4679078 32.6694215,16.1133648 32.6499174,15.6952487 Z"
                id="Shape"
              ></path>
              <ellipse
                id="Oval"
                transform="translate(30.927669, 13.448671) rotate(-89.920522) translate(-30.927669, -13.448671) "
                cx="30.9276686"
                cy="13.4486707"
                rx="1"
                ry="1"
              ></ellipse>
              <ellipse
                id="Oval"
                cx="2.22834711"
                cy="13.7978327"
                rx="2.18446281"
                ry="2.19083079"
              ></ellipse>
              <ellipse
                id="Oval"
                transform="translate(4.983706, 9.416303) rotate(-2.722496) translate(-4.983706, -9.416303) "
                cx="4.98370586"
                cy="9.41630295"
                rx="1.94560406"
                ry="1.94880857"
              ></ellipse>
              <ellipse
                id="Oval"
                transform="translate(8.123992, 5.858430) rotate(-2.739664) translate(-8.123992, -5.858430) "
                cx="8.12399183"
                cy="5.85843019"
                rx="1.75058118"
                ry="1.7556643"
              ></ellipse>
              <ellipse
                id="Oval"
                transform="translate(11.615130, 3.237264) rotate(-2.728219) translate(-11.615130, -3.237264) "
                cx="11.6151301"
                cy="3.23726351"
                rx="1.57502034"
                ry="1.57959384"
              ></ellipse>
              <ellipse
                id="Oval"
                transform="translate(15.352911, 1.752578) rotate(-2.739664) translate(-15.352911, -1.752578) "
                cx="15.3529115"
                cy="1.75257832"
                rx="1.41655664"
                ry="1.42066986"
              ></ellipse>
              <ellipse
                id="Oval"
                transform="translate(19.065916, 1.508664) rotate(-2.728219) translate(-19.065916, -1.508664) "
                cx="19.0659163"
                cy="1.50866403"
                rx="1.27513256"
                ry="1.27883526"
              ></ellipse>
              <ellipse
                id="Oval"
                transform="translate(22.364723, 2.534244) rotate(-2.733941) translate(-22.364723, -2.534244) "
                cx="22.3647226"
                cy="2.53424425"
                rx="1.14835624"
                ry="1.15169075"
              ></ellipse>
              <ellipse
                id="Oval"
                transform="translate(25.014801, 4.358713) rotate(-2.716773) translate(-25.014801, -4.358713) "
                cx="25.014801"
                cy="4.35871335"
                rx="1.03374961"
                ry="1.03675148"
              ></ellipse>
              <ellipse
                id="Oval"
                transform="translate(27.074709, 6.549451) rotate(-2.722496) translate(-27.074709, -6.549451) "
                cx="27.0747087"
                cy="6.54945123"
                rx="1"
                ry="1"
              ></ellipse>
              <path
                d="M27.8567769,8.8929147 C27.878719,9.35748819 28.2712397,9.71447624 28.7320248,9.69247013 C29.1952479,9.67046402 29.5511983,9.27679911 29.5292562,8.81222562 C29.507314,8.35009725 29.1147934,7.9931092 28.6540083,8.01511531 C28.1907851,8.03712142 27.8323967,8.42834121 27.8567769,8.8929147 Z"
                id="Shape"
              ></path>
              <ellipse
                id="Oval"
                transform="translate(29.956857, 11.160946) rotate(-2.711050) translate(-29.956857, -11.160946) "
                cx="29.956857"
                cy="11.1609464"
                rx="1"
                ry="1"
              ></ellipse>
            </g>
            <g
              id="ResMed"
              transform="translate(0.000000, 32.031120)"
              fillRule="nonzero"
            >
              <path
                d="M10.0860744,5.06140595 C9.90566116,5.37438177 9.66917355,5.67268686 9.38636364,5.89763823 C9.04504132,6.14948597 8.68665289,6.31330925 7.86991736,6.5969436 L9.58140496,10.7732148 L6.72404959,10.7732148 L5.34169421,6.99794387 L3.5107438,6.99794387 L2.65012397,10.7732148 L0.046322314,10.7732148 L2.42338843,0.244512365 L7.0507438,0.244512365 C7.27260331,0.244512365 7.48227273,0.244512365 7.70413223,0.259183106 C8.00157025,0.28852459 8.68665289,0.349652681 9.36929752,0.826451792 C9.83008264,1.15165324 10.5298805,1.85340372 10.5298805,3.30091692 C10.5322314,3.61633787 10.4859091,4.34498472 10.0860744,5.06140595 Z M7.70413223,2.63095304 C7.43595041,2.28619061 7.1238843,2.16882467 6.38028926,2.16882467 L4.61028926,2.16882467 L3.95446281,5.0467352 L6.15599174,5.0467352 C6.21450413,5.0467352 6.48512397,5.03206446 6.72161157,4.98560711 C7.18239669,4.88291192 7.47983471,4.6432898 7.70169421,4.2398444 C7.91136364,3.85106974 7.92599174,3.53809391 7.92599174,3.35959989 C7.92842975,3.24223395 7.92842975,2.91214226 7.70413223,2.63095304 Z"
                id="Shape"
              ></path>
              <path
                d="M24.3070248,5.53820506 C24.0851653,5.22522923 24.0266529,5.13475966 23.8779339,5.00027785 C23.5049174,4.65551542 22.9246694,4.508808 22.4346281,4.508808 C21.7958678,4.508808 21.4545455,4.7777716 21.4545455,5.10541817 C21.4545455,5.52353432 21.9884711,5.65801612 22.6589256,5.85118088 C22.9856198,5.94165046 23.297686,6.02967491 23.6121901,6.14948597 C24.3850413,6.43312031 25.1432645,6.80477911 25.4114463,7.59699917 C25.513843,7.88063351 25.513843,8.19360934 25.513843,8.28407891 C25.513843,9.19366491 24.9189669,9.81961656 24.7092975,10.0127813 C24.2192562,10.4749097 23.2659917,11.0128369 21.7056612,11.0128369 C21.1546694,11.0128369 19.5797107,10.9834954 18.4484711,9.67046402 C18.285124,9.47729925 18.1949174,9.37215893 17.9730579,8.97115866 L19.8917769,8.01756043 C20.0258678,8.25473743 20.1014463,8.37454849 20.1745868,8.46501806 C20.3988843,8.73398166 20.9328099,9.16676855 21.8714463,9.16676855 C21.9884711,9.16676855 22.2883471,9.14965268 22.6150413,9.04695749 C22.7954545,8.9858294 22.9271074,8.91247569 23.0319421,8.76332315 C23.0611983,8.7168658 23.1221488,8.6141706 23.1221488,8.4796888 C23.1221488,8.42100583 23.1075207,8.31586552 23.0319421,8.2107252 C22.8515289,7.95643234 22.5272727,7.86840789 21.9909091,7.70213948 C20.4744628,7.22534037 19.8186364,7.000389 19.3602893,6.25707141 C19.2725207,6.10791887 19.0628512,5.71914421 19.0628512,5.2423451 C19.0628512,5.01983884 19.1067355,4.6017227 19.4041736,4.13959433 C19.8210744,3.48185607 20.7426446,2.81189219 22.4687603,2.81189219 C24.2387603,2.81189219 25.1164463,3.46718533 25.6235537,4.04912476 C25.7552066,4.21294804 25.8600413,4.34742984 26.0526446,4.68974715 L24.3070248,5.53820506 Z"
                id="Shape"
              ></path>
              <polygon
                id="Shape"
                points="37.1285537 10.7732148 34.6905372 10.7732148 36.5653719 2.62850792 32.6401653 10.7732148 30.4386364 10.7732148 30.1411983 2.50869686 28.3419421 10.7732148 25.8868595 10.7732148 28.2395455 0.242067241 32.1184298 0.242067241 32.296405 7.14709642 35.553595 0.244512365 39.4934298 0.244512365"
              ></polygon>
              <path
                d="M53.977686,10.7732148 L51.6859504,10.7732148 L51.7907851,10.2352876 C51.6713223,10.323312 51.5542975,10.3991109 51.4348347,10.4895804 C51.1520248,10.6680745 50.6010331,10.9810503 49.7379752,10.9810503 C48.8602893,10.9810503 48.3556198,10.6240622 48.087438,10.3991109 C47.5973967,9.99566546 47.0025207,9.24990275 47.0025207,7.74370659 C47.0025207,7.23512087 47.0927273,5.95143095 47.8655785,4.72886913 C48.9066116,3.08819116 50.3499174,2.83634343 51.0764463,2.83634343 C51.3446281,2.83634343 52.1028512,2.86568491 52.7416116,3.34248402 C52.9951653,3.53564879 53.1731405,3.78994165 53.2340909,3.8779661 L54.0508264,0.244512365 L56.3571901,0.244512365 L53.977686,10.7732148 Z M52.5928926,5.52353432 C52.4002893,4.95626563 51.9102479,4.61394832 51.327562,4.6432898 C50.9252893,4.65796054 50.6278512,4.85112531 50.5230165,4.92692415 C49.6745868,5.49419283 49.3040083,6.7314254 49.3040083,7.69969436 C49.3040083,8.22295082 49.4234711,8.5212559 49.557562,8.72909141 C49.7940496,9.10319533 50.1378099,9.23767713 50.5693388,9.23767713 C50.9399174,9.23767713 51.5640496,9.11786607 52.071157,8.35987774 C52.4563636,7.77793832 52.6806612,6.83656571 52.6806612,6.16415671 C52.6830992,5.92453459 52.6684711,5.74848569 52.5928926,5.52353432 Z"
                id="Shape"
              ></path>
              <path
                d="M18.0754545,7.34270631 C18.1047107,7.01505974 18.136405,6.67274243 18.136405,6.32797999 C18.136405,6.16415671 18.136405,5.64090025 17.987686,5.13475966 C17.8828512,4.73131425 17.6902479,4.37188108 17.4245041,4.03200889 C16.5004959,2.88280078 15.0888843,2.82411781 14.6134711,2.82411781 C14.2258264,2.82411781 13.2286777,2.86813004 12.3217355,3.43539872 C11.356281,4.04423451 10.6419421,5.13475966 10.3737603,6.25462629 C10.2542975,6.7314254 10.2542975,7.11775493 10.2542975,7.29869408 C10.2542975,8.79021951 10.9686364,10.1325924 12.3363636,10.6998611 C13.0190083,10.9834954 13.718719,10.9981662 13.9869008,10.9981662 C15.8763636,10.9981662 16.812562,10.1179216 17.2733471,9.52131148 C17.405,9.34526257 17.5293388,9.1618783 17.6488017,8.96871353 L15.8641736,8.08113365 C15.7447107,8.27429842 15.635,8.46501806 15.486281,8.6239511 C15.1303306,9.00050014 14.5939669,9.22056127 14.0429752,9.22056127 C13.8796281,9.22056127 13.5504959,9.22056127 13.1799174,9.01272576 C12.3607438,8.56526813 12.4802066,7.55054182 12.4948347,7.34270631 L18.0754545,7.34270631 L18.0754545,7.34270631 Z M13.4944215,4.86579605 C13.6748347,4.71664351 14.016157,4.43300917 14.6256612,4.43300917 C15.488719,4.43300917 15.8885537,5.00027785 16.0080165,5.31325368 C16.081157,5.53820506 16.081157,5.84873576 16.081157,5.89519311 L12.7971488,5.89519311 C13.0775207,5.2839122 13.2262397,5.10541817 13.4944215,4.86579605 Z"
                id="Shape"
              ></path>
              <path
                d="M46.4783471,7.34270631 C46.5076033,7.01505974 46.5392975,6.67274243 46.5392975,6.32797999 C46.5392975,6.16415671 46.5392975,5.64090025 46.3905785,5.13475966 C46.2857438,4.73131425 46.0931405,4.37188108 45.8249587,4.03200889 C44.9033884,2.88280078 43.4893388,2.82411781 43.0163636,2.82411781 C42.628719,2.82411781 41.6315702,2.86813004 40.7246281,3.43539872 C39.7591736,4.04423451 39.0448347,5.13475966 38.7766529,6.25462629 C38.6571901,6.7314254 38.6571901,7.11775493 38.6571901,7.29869408 C38.6571901,8.79021951 39.3715289,10.1325924 40.7392562,10.6998611 C41.4219008,10.9834954 42.1216116,10.9981662 42.3897934,10.9981662 C44.2792562,10.9981662 45.2154545,10.1179216 45.6786777,9.52131148 C45.8103306,9.34526257 45.9322314,9.1618783 46.0541322,8.96871353 L44.2695041,8.08113365 C44.1524793,8.27429842 44.0403306,8.46501806 43.8940496,8.6239511 C43.5380992,9.00050014 43.0017355,9.22056127 42.4531818,9.22056127 C42.2898347,9.22056127 41.9607025,9.22056127 41.592562,9.01272576 C40.7733884,8.56526813 40.8904132,7.55054182 40.9074793,7.34270631 L46.4783471,7.34270631 L46.4783471,7.34270631 Z M41.897314,4.86579605 C42.0777273,4.71664351 42.4190496,4.43300917 43.0285537,4.43300917 C43.8916116,4.43300917 44.2914463,5.00027785 44.4109091,5.31325368 C44.4840496,5.53820506 44.4840496,5.84873576 44.4840496,5.89519311 L41.2000413,5.89519311 C41.4804132,5.2839122 41.6291322,5.10541817 41.897314,4.86579605 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
      <g id="V01-" transform="translate(-1489.000000, -2090.000000)"></g>
    </g>
  </svg>
);

export default ResMedLogo;
